// import { navigate } from 'hookrouter'
import React, { FC, useEffect, useState } from 'react'
// import { ListGroup } from 'react-bootstrap'
import { ProjectRolesParam } from 'types'
import { Button, Modal } from 'react-bootstrap'
// import { navigate } from 'hookrouter'
import { useCompanyManagersNew, useOtherRoles } from 'hooks/useCompanyManagers'
import { TemplateDeletionWarningModal } from 'components/TemplateDeletionWarningModal'
import {
  deleteRole,
  reinviteUser,
  getPermissionsList,
} from 'state/async_actions'
import { useAppContext } from 'state/context'
import { usePermissions } from 'hooks/useCompanyManagers'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
// import { WarningModal } from 'components/WarningModal'

export const ProjectUsersList: FC<ProjectRolesParam> = ({
  companyId,
  projectId,
  projectUserType,
}) => {
  let userRoleType: any = 1
  const [store, dispatch] = useAppContext()
  const { folder_access = [] } = store

  const companyManagers = useCompanyManagersNew(companyId)

  const [deleteUserRole, setDeleteRole] = React.useState<
    (() => () => void) | undefined
  >()

  const [isShowFolderAcc, setIsShowFolderAcc] = useState(false)
  const [selFolderAcc, setSelFolderAcc] = useState<any>({})

  const projectList = useProjectsForCompany(companyId)
  const selectedProject: any =
    projectList.find((company: any) => company.id === projectId) || {}

  if (selectedProject.isCompanyManager) userRoleType = 1
  else if (selectedProject.isProjectManager) userRoleType = 2
  else if (selectedProject.isProjectCoordinator) userRoleType = 5
  else if (selectedProject.isSuperForeman) userRoleType = 3
  else if (selectedProject.isSubCordinator) userRoleType = 4

  useEffect(() => {
    if (companyId) getPermissionsList(dispatch, companyId, userRoleType)
  }, [dispatch, projectId, userRoleType])

  const permissionsList: any = usePermissions(userRoleType)

  let id, url: any
  if (projectUserType == 2) id = 'project_managers'
  else if (projectUserType == 3) id = 'super_foremans'
  else if (projectUserType == 4) id = 'sub_contractors'
  else if (projectUserType == 5) id = 'project_coordinators'
  const otherRoles = useOtherRoles(id) || []

  let otherRolesWithFolderAccess: any = otherRoles.map((role: any) => {
    folder_access.forEach((folder: any) => {
      if (role.id === folder.roleId) {
        role = { folderAccList: folder, ...role }
      }
    })
    return role
  })

  if (projectUserType) {
    if (projectUserType == 1) url = 'company_manager_roles'
    if (projectUserType == 2) url = 'project_manager_roles'
    else if (projectUserType == 3) url = 'super_foreman_roles'
    else if (projectUserType == 4) url = 'sub_contractor_roles'
    else if (projectUserType == 5) url = 'project_coordinator_roles'
  }
  const resetRoleDeletionWarning = () => {
    setDeleteRole(undefined)
  }

  const handleClose = () => {
    setSelFolderAcc({})
    setIsShowFolderAcc(false)
  }

  const warnAndDeleteRole = (id: any) => {
    setDeleteRole(() => () => {
      deleteRole(dispatch, url, id, projectId, projectUserType, companyId)
      // fetchTemplateDirectories(dispatch, projectId, templateDocumentId)
      // directoryPath(companyId, projectId, templateDocumentId);
    })
  }

  const warningText = `Do you want to Remove this User?`
  const sendReinvitation = (userId: number) => {
    reinviteUser(dispatch, userId)
  }

  const onFolderAccHandler = (role: any = {}) => {
    setSelFolderAcc(role)
    setIsShowFolderAcc(!isShowFolderAcc)
  }

  const renderListOfRoles = () => {
    if (projectUserType == 1) {
      return companyManagers.map((manager: any) => (
        <div className="row role-list-card">
          <div className="col-9" style={{ paddingTop: '6px' }}>
            <span>{manager?.email}</span>&nbsp;
            {/* <span>{manager?.lastName}</span> */}
          </div>
          <div className="col-2">
            {permissionsList?.invite?.invite_company_manager && (
              <Button onClick={() => sendReinvitation(manager?.id)}>
                Resend Invitation
              </Button>
            )}
          </div>
          <div className="col-1">
            {permissionsList?.invite?.invite_company_manager && (
              <Button
                className="disabled-button"
                onClick={() => warnAndDeleteRole(manager.id)}>
                Remove
              </Button>
            )}
          </div>
        </div>
      ))
    } else if (projectUserType == 4) {
      return otherRolesWithFolderAccess.map((subcontractor: any) => {
        return (
          <div className="row role-list-card">
            <div className="col-9 role-folders">
              <span>{subcontractor?.email}</span>&nbsp;
              <span className="folder-access">
              {permissionsList?.invite?.invite_other_roles ? "Access invitation sent for" : "Access allowed to" }
                <Button
                  className="folder-access-button"
                  onClick={() => onFolderAccHandler(subcontractor)}>
                  <span className='folder-access-count'>{subcontractor?.folderAccList?.folderList?.length || 0} </span>
                   folders
                </Button>
              </span>
              {subcontractor.id == selFolderAcc?.id && (
                <FolderPopup
                  handleClose={handleClose}
                  isShowFolderAcc={isShowFolderAcc}
                  inviteAccess={permissionsList?.invite}
                  {...selFolderAcc}
                />
              )}
            </div>
            <div className="col-2">
              {permissionsList?.invite?.invite_other_roles && (
                <Button onClick={() => sendReinvitation(subcontractor?.id)}>
                  Resend Invitation
                </Button>
              )}
            </div>
            <div className="col-1">
              {permissionsList?.invite?.invite_other_roles && (
                <Button
                  className="disabled-button"
                  onClick={() => warnAndDeleteRole(subcontractor.id)}>
                  Remove
                </Button>
              )}
            </div>
          </div>
        )
      })
    }

    return otherRoles?.map((role: any) => {
      return (
        <div className="row role-list-card">
          <div className="col-9 role-folders">
            <span>{role?.email}</span>&nbsp;
            {/* <span>{role?.last_name}</span> */}
          </div>
          <div className="col-2">
            {((projectUserType == 2 &&
              permissionsList?.invite?.invite_project_manager) ||
              (projectUserType == 5 &&
                permissionsList?.invite?.invite_other_roles) ||
              (projectUserType == 3 &&
                permissionsList?.invite?.invite_other_roles)) && (
              <Button onClick={() => sendReinvitation(role?.id)}>
                Resend Invitation
              </Button>
            )}
          </div>
          <div className="col-1">
            {((projectUserType == 2 &&
              permissionsList?.invite?.invite_project_manager) ||
              (projectUserType == 5 &&
                permissionsList?.invite?.invite_other_roles) ||
              (projectUserType == 3 &&
                permissionsList?.invite?.invite_other_roles)) && (
              <Button
                className="disabled-button"
                onClick={() => warnAndDeleteRole(role.id)}>
                Remove
              </Button>
            )}
          </div>
        </div>
      )
    })
  }

  return (
    <>
      {deleteUserRole && (
        <TemplateDeletionWarningModal
          confirmAction={deleteUserRole}
          updateParentState={resetRoleDeletionWarning}
          text={warningText}
        />
      )}

      {renderListOfRoles()}
    </>
  )
}

export const FolderPopup = (props: any) => {
  const { email, folderAccList = {}, handleClose, isShowFolderAcc, inviteAccess= {} } = props
  const { folderList = [] } = folderAccList

  return (
    <Modal className="folder-popup" show={isShowFolderAcc} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {email}
          <span className="folder-heading">
            {inviteAccess?.invite_other_roles ? "is invited for access to  below folders": " is allowed access to below folders"}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          <ul>
            {folderList?.map((template: any) => (
              <li key={template.template_directory_id}>
                {template.template_directory_name}
              </li>
            ))}
          </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-primary"
          variant="primary"
          onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
